// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5398e57f] .el-table{overflow:visible!important}.font[data-v-5398e57f]{color:red;margin:0 5px}.dialog-tab-footer[data-v-5398e57f]{text-align:right;margin:20px 0}", ""]);
// Exports
module.exports = exports;
